import React from 'react';
import { DEFAULT_MEDIA_POINT } from '@share/constants';

interface IState {
  matches: boolean;
}

interface IProps {
  children?: React.ReactNode;
}

/**
 * Clones its children with a `matches` prop reflecting the desktop media query.
 *
 * The props type was `React.ReactNode`, which is not a props shape - that made
 * `<Responsive>` unusable as a JSX component under strict TS (TRAV23 activities-front
 * merge). Corrected to a real props interface; behaviour is unchanged.
 */
export class Responsive extends React.Component<IProps, IState> {
  state: IState = {
    matches: window.matchMedia(`(min-width: ${DEFAULT_MEDIA_POINT}px)`).matches,
  };

  componentDidMount(): void {
    const handler = (e: IState) => this.setState({ matches: e.matches });
    window.matchMedia(`(min-width: ${DEFAULT_MEDIA_POINT}px)`).addListener(handler);
  }

  render(): React.ReactNode {
    return React.Children.map(this.props.children, (child) => {
      return React.cloneElement(child as React.ReactElement<{ matches?: boolean }>, {
        matches: this.state.matches,
      });
    });
  }
}
